import React from "react";
import { cn } from "../../../common/u1/cn";
import { formatDateWithOrdinalAndShortMonth } from "../../../../utils/Helper";
import { iconForUpdate } from "../../../common/u1/updateIcon";

/* The list of changes behind a followed company's strip. */
export const UpdateRow = ({ update, isNew = false }) => {
  const Icon = iconForUpdate(update?.content);

  return (
    <li
      className={cn(
        "flex items-start gap-3 border-b border-[var(--line)] px-4 py-3 last:border-b-0",
        isNew && "border-l-[3px] border-l-[var(--coral)] bg-[var(--unread-bg)]"
      )}
    >
      <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[var(--coral-soft)] text-[var(--coral)]">
        <Icon size={16} />
      </span>

      <span className="min-w-0 grow basis-0">
        <span className="block text-[14px] font-semibold text-[var(--ink)] font-sans">
          {update?.content}
        </span>
        <span className="mt-0.5 block text-[12.5px] text-[var(--muted)] font-sans">
          {formatDateWithOrdinalAndShortMonth(update?.timestamp)}
        </span>
      </span>

      {isNew && (
        <span className="shrink-0 rounded-full bg-[var(--coral-soft)] px-2 py-0.5 text-[10px] font-bold uppercase tracking-[.06em] text-[var(--coral-deep)] font-sans">
          New
        </span>
      )}
    </li>
  );
};

export const CompanyUpdates = ({ updates = [], viewedAt, id }) => {
  if (updates.length === 0) {
    return (
      <p id={id} className="m-0 px-4 py-4 text-[13.5px] text-[var(--muted)] font-sans">
        No changes recorded yet.
      </p>
    );
  }

  return (
    <ul id={id} className="m-0 list-none p-0">
      {updates.map((update) => (
        <UpdateRow
          key={`${update.content}-${update.timestamp}`}
          update={update}
          isNew={new Date(update.timestamp) > new Date(viewedAt)}
        />
      ))}
    </ul>
  );
};

export default CompanyUpdates;
